import { Button, Card, Row, Col } from 'react-bootstrap';
import { FaFileAlt } from 'react-icons/fa';

interface Props {
  service: string;
  date: string;
  timeSlot: string;
  location: string;
  advisor: string;
  price: number;
  onEdit: () => void;
  onNext: () => void;
}

const ReservationSummary = ({
  service,
  date,
  timeSlot,
  location,
  advisor,
  price,
  onEdit,
  onNext,
}: Props) => {
  return (
    <div >
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <Card className="appointment-border rounded-0 shadow-sm">
            <Card.Header className="bg-blue text-light rounded-0 py-3 py-md-4 border-0">
              <p className="mb-0  fw-light letter-spacing-1 fw-semibold text-center ">
                <span className="responsive-text">Reservation Summary</span>
              </p>
            </Card.Header>
            <Card.Body className="p-3 p-md-5">
              <Row className="mb-3 mb-md-4">
                <Col
                  xs={12}
                  md={4}
                  className="text-uppercase small fw-bold text-muted mb-2 mb-md-0"
                >
                  Service
                </Col>
                <Col xs={12} md={8}>
                  {service}
                </Col>
              </Row>
              <Row className="mb-3 mb-md-4">
                <Col
                  xs={12}
                  md={4}
                  className="text-uppercase small fw-bold text-muted mb-2 mb-md-0"
                >
                  Date & Time
                </Col>
                <Col xs={12} md={8}>
                  {date} at {timeSlot}
                </Col>
              </Row>
              <Row className="mb-3 mb-md-4">
                <Col
                  xs={12}
                  md={4}
                  className="text-uppercase small fw-bold text-muted mb-2 mb-md-0"
                >
                  Location
                </Col>
                <Col xs={12} md={8}>
                  {location}
                </Col>
              </Row>
              <Row className="mb-3 mb-md-4">
                <Col
                  xs={12}
                  md={4}
                  className="text-uppercase small fw-bold text-muted mb-2 mb-md-0"
                >
                  Advisor
                </Col>
                <Col xs={12} md={8}>
                  {advisor}
                </Col>
              </Row>
              <Row className="mb-3 mb-md-4">
                <Col
                  xs={12}
                  md={4}
                  className="text-uppercase small fw-bold text-muted mb-2 mb-md-0"
                >
                  Price
                </Col>
                <Col xs={12} md={8}>
                  AED {price}
                </Col>
              </Row>
              <div className="d-flex flex-column flex-md-row justify-content-end mt-4 mt-md-5 pt-3 border-top border-dark">
                <Button
                  onClick={onEdit}
                  className="rounded-2 fw-semibold letter-spacing-1 btn-outline-dark mb-2 mb-md-0 me-md-3"
                  style={{
                    minWidth: '120px',
                    minHeight: '45px',
                    outline: 'none',
                    boxShadow: 'none',
                    border: '1px solid #082341',
                    background: 'transparent',
                    color: '#082341',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.outline = 'none';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  Edit
                </Button>
                <Button
                  onClick={onNext}
                  className="rounded-2 fw-semibold letter-spacing-1 fw-light btn-dark"
                  style={{
                    minWidth: '160px',
                    minHeight: '45px',
                    outline: 'none',
                    boxShadow: 'none',
                    border: 'none',
                    background: '#082341',
                    color: '#ffffff',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = '#082341';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.outline = 'none';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  Confirm Booking
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ReservationSummary;